import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';

import { CandidateDetailsModule } from '../candidate-details/candidate-details.module';
import { GroupsModule } from '../groups/groups.module';
import { CandidateCreationModalComponent } from './candidate-creation-modal/candidate-creation-modal.component';
import { CandidateUpdateModalComponent } from './candidate-update-modal/candidate-update-modal.component';
import { CandidatesRoutingModule } from './candidates-routing.module';
import { CandidatesComponent } from './candidates.component';
import { CandidateActionsComponent } from './candidate-actions/candidate-actions.component';
import { FilterComponent } from './filter/filter.component';
import { CandidatesAddToGroupComponent } from './candidates-add-to-group/candidates-add-to-group.component';
import { GroupAddCandidatesComponent } from './group-add-candidates/group-add-candidates.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  imports: [
    CommonModule,
    CandidatesRoutingModule,
    MatSlideToggleModule,
    CandidateDetailsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatToolbarModule,
    GroupsModule,
    CandidatesComponent,
    CandidateCreationModalComponent,
    CandidateUpdateModalComponent,
    FilterComponent,
    CandidateActionsComponent,
    CandidatesAddToGroupComponent,
    GroupAddCandidatesComponent,
  ],
  exports: [FilterComponent],
})
export class CandidatesModule {}
